import {configurationForm} from '../helpers/fieldGroups';

export function getOrgClientConfig() {

  switch (sessionStorage.getItem('org')) {
	  case 'ingle':
	    return getIngleConfigs();
	  case 'rimi':
	    return getRimiConfigs();
	  case 'msg':
	    return getMsgConfigs();
	  case 'visitcanada':
	    return getVisitCanadaConfigs();
	  case 'insurecanada':
	    return getInsureCanadaConfigs();
	  case 'alumo':
	    return getAlumoConfigs();
	}
}

function getIngleConfigs() {

	return {
    lloydscanuckvoyage: {          
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: true,
          radioButtons: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'lloydscanuckvoyage?'
        }
      ],
      configuration_form: configurationForm('lloydscanuckvoyage'),
    },
    goosevisitortocanada: {
      org: 'ingle',
      readonly: true,
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      configuration_form: configurationForm('goosevisitortocanada'),
      upload_path: [{
          canUpload: false
      }]
    },
    goosesquareone: {
      org: 'ingle',
      readonly: true,
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      configuration_form: configurationForm('goosesquareone'),
      upload_path: [{
          canUpload: false
      }]
    },
    lloydscomprehensiveplus: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'print',
              label: 'Print Format'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'lloydscomprehensiveplus?'
        }
      ],
      configuration_form: configurationForm('lloydscomprehensiveplus')
    },
    lloydsis: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          name: 'Silver',
          link: 'lloydsis?coverage=silver'
        },
        {
          name: 'Gold',
          link: 'lloydsis?coverage=gold'
        },
      ],
      configuration_form: configurationForm('lloydsis'),
    },
    lloydsdiscovercanada: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      // upload_path: uploadPathGroup(
      //   {
      //     canUpload: true,
      //     radioButtons: true,
      //     Fulfillment_options: {'email', 'none'}
      //   }
      // )
      upload_path: [
        {
          canUpload: true,
          radioButtons: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'lloydsdiscovercanada?'
        }
      ],
      configuration_form: configurationForm('lloydsdiscovercanada')
    },
    lloydsexplorecanadais: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'lloydsexplorecanadais?'
        }
      ],
      configuration_form: configurationForm('lloydsexplorecanadais')
    },
    lloydsstudycanadais: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'lloydsstudycanadais?'
        }
      ],
      configuration_form: configurationForm('lloydsstudycanadais')
    },
    lloydsascnoop: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          link: 'lloydsascnoop?'
        }
      ],
      configuration_form: configurationForm('lloydsascnoop'),
    },
    lloydsascnallincl: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          link: 'lloydsascnallincl?'
        }
      ],
      configuration_form: configurationForm('lloydsascnallincl'),
    },
    lloydsascnnonmed: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          link: 'lloydsascnnonmed?'
        }
      ],
      configuration_form: configurationForm('lloydsascnnonmed'),
    },
    lloydsessentialplanis: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'lloydsessentialplanis?'
        }
      ],
      configuration_form: configurationForm('lloydsessentialplanis')
    },
    lloydsessentialworldwideplanis: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'lloydsessentialworldwideplanis?'
        }
      ],
      configuration_form: configurationForm('lloydsessentialworldwideplanis')
    },
    lloydsusis: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          name: 'Basic',
          link: 'lloydsusis?coverage=basic'
        },
        {
          name: 'Advantage',
          link: 'lloydsusis?coverage=advantage'
        },
        {
          name: 'Elite',
          link: 'lloydsusis?coverage=elite'
        }
      ],
      configuration_form: configurationForm('lloydsusis')
    },
    lloydsmycanadais: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'lloydsmycanadais?'
        }
      ],
      configuration_form: configurationForm('lloydsmycanadais')
    },
    lloydsmycanadaplusis: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'lloydsmycanadaplusis?'
        }
      ],
      configuration_form: configurationForm('lloydsmycanadaplusis')
    },
    lloydsoutboundstudent: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'lloydsoutboundstudent?'
        }
      ],
      configuration_form: configurationForm('lloydsoutboundstudent')
    },
    lloydsetrstudent: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'lloydsetrstudent?'
        }
      ],
      configuration_form: configurationForm('lloydsetrstudent')
    },
    studentaccidentplan: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'studentaccidentplan?'
        }
      ],
      configuration_form: configurationForm('studentaccidentplan'),
    },
    tpageneric: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'tpageneric?'
        }
      ],
      configuration_form: configurationForm('tpageneric')
    },
    blanket: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'blanket?'
        }
      ],
      configuration_form: configurationForm('blanket')
    },
    ubcimedblanket: {
      org: 'ingle',
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'ubcimedblanket?'
        }
      ],
      configuration_form: configurationForm('ubcimedblanket')
    },
    alumo: {
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      configuration_form: configurationForm('alumo')
    },
    tugoemergencymedical: {
      readonly: true,
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      configuration_form: configurationForm('tugoemergencymedical'),
      upload_path: [{
        canUpload: false
      }],
      form_path: [
        {
          link: 'tugoemergencymedical?'
        }
      ]
    }
  }
}

function getRimiConfigs() {
	return {
    rimivisitorstocanada: {
      org: 'rimi',
      restrictVoid: true,
      defaultEmail: null,
      partial_skip_validation: false,
      searchQuotes: true,
      upload_path: [
        {
          canUpload: false,
          radioButtons: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'arktrimivisitorstocanada?'
        }
      ],
      configuration_form: configurationForm('rimivisitorstocanada'),
      hide_on_product_screen: true,
    },
    rimicanuckvoyage: {
      org: 'rimi',
      restrictVoid: true,
      defaultEmail: null,
      partial_skip_validation: false,
      searchQuotes: true,
      upload_path: [
        {
          canUpload: false,
          radioButtons: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'rimicanuckvoyage?'
        }
      ],
      configuration_form: configurationForm('rimicanuckvoyage'),
    },
    rimissis: {
      org: 'rimi',
      restrictVoid: true,
      defaultEmail: null,
      partial_skip_validation: true,
      searchQuotes: true,
      upload_path: [
        {
          canUpload: false,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'arktrimissis?'
        }
      ],
      configuration_form: configurationForm('rimissis'),
      hide_on_product_screen: true,
    },
    rimicanuckvoyagenonmed: {
      org: 'rimi',
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          link: 'rimicanuckvoyagenonmed?'
        }
      ],
      configuration_form: configurationForm('rimicanuckvoyagenonmed'),
    },
    arktrimissis: {
      org: 'rimi',
      restrictVoid: true,
      defaultEmail: null,
      partial_skip_validation: true,
      searchQuotes: true,
      upload_path: [
        {
          canUpload: false,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'arktrimissis?'
        }
      ],
      configuration_form: configurationForm('rimissis'),
      hide_on_product_screen: true,
    },
    arktrimivisitorstocanada: {
      org: 'rimi',
      restrictVoid: true,
      defaultEmail: null,
      partial_skip_validation: false,
      searchQuotes: true,
      upload_path: [
        {
          canUpload: false,
          radioButtons: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'arktrimivisitorstocanada?'
        }
      ],
      configuration_form: configurationForm('rimivisitorstocanada'),
      hide_on_product_screen: true,
    },
    arkrimissis: {
      org: 'rimi',
      restrictVoid: true,
      defaultEmail: null,
      partial_skip_validation: true,
      searchQuotes: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'arkrimissis?'
        }
      ],
      configuration_form: configurationForm('rimissis'),
    },
    arkrimivisitorstocanada: {
      org: 'rimi',
      restrictVoid: true,
      defaultEmail: null,
      partial_skip_validation: false,
      searchQuotes: true,
      upload_path: [
        {
          canUpload: false,
          radioButtons: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'arkrimivisitorstocanada?'
        }
      ],
      configuration_form: configurationForm('rimivisitorstocanada'),
    },
    rimisecureadvantageplus: {
      org: 'rimi',
      restrictVoid: true,
      defaultEmail: null,
      partial_skip_validation: false,
      searchQuotes: true,
      upload_path: [
        {
          canUpload: false,
          radioButtons: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'rimisecureadvantageplus?'
        }
      ],
      configuration_form: configurationForm('rimisecureadvantageplus'),
      stripeAccount: 'rimisecureadvantageplus'
    }
  };
}

function getMsgConfigs() {
	return {
    msgascnallincl: {
      org: 'msg',
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          link: 'msgascnallincl?'
        }
      ],
      configuration_form: configurationForm('msgascnallincl'),
    },
    msgascnnonmed: {
      org: 'msg',
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          link: 'msgascnnonmed?'
        }
      ],
      configuration_form: configurationForm('msgascnnonmed'),
    },
    msgemergencymedical: {
      org: 'msg',
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: true,
          radioButtons: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'msgemergencymedical?'
        }
      ],
      configuration_form: configurationForm('msgemergencymedical'),
    },
    msgis: {
      org: 'msg',
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          name: 'Silver',
          link: 'msgis?coverage=silver'
        },
        {
          name: 'Gold',
          link: 'msgis?coverage=gold'
        },
      ],
      configuration_form: configurationForm('msgis'),
    },
    msgvisitorstocanada: {
      org: 'msg',
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: true,
          radioButtons: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'msgvisitorstocanada?'
        }
      ],
      configuration_form: configurationForm('msgvisitorstocanada')
    }
  };
}

function getVisitCanadaConfigs() {
	return {
    visitcanadavisitors: {
      org: 'visitcanada',
      restrictVoid: true,
      defaultEmail: null,
      partial_skip_validation: false,
      searchQuotes: true,
      upload_path: [
        {
          canUpload: false,
          radioButtons: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: '2visitcanadavisitors?'
        }
      ],
      configuration_form: configurationForm('visitcanadavisitors'),
    },
    visitcanadais: {
      org: 'visitcanada',
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: '2visitcanadais?'
        }
      ],
      configuration_form: configurationForm('visitcanadais')
    }
  };
}

function getInsureCanadaConfigs() {
	return {
    insurecanadais: {
      org: 'insurecanada',
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'insurecanadais?'
        }
      ],
      configuration_form: configurationForm('insurecanadais')
    },
    insurecanadavisitor: {
      org: 'insurecanada',
      restrictVoid: true,
      defaultEmail: null,
      partial_skip_validation: false,
      searchQuotes: true,
      upload_path: [
        {
          canUpload: false,
          radioButtons: true,
          options: [
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'none',
              label: 'No Fulfillment'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'insurecanadavisitor?'
        }
      ],
      configuration_form: configurationForm('insurecanadavisitor')
    }
  };
}

function getAlumoConfigs() {
	return {
    alumois: {
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'print',
              label: 'Print Format'
            }
          ]
        }
      ],
      configuration_form: configurationForm('alumois')
    },
    alumoetrstudent: {
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          link: 'alumoetrstudent?'
        }
      ],
      configuration_form: configurationForm('alumoetrstudent')
    }
  };
}


// WEBPACK FOOTER //
// ./src/clients/orgs.js